import React from 'react';

const About = () => {
  return (
    <>
      <div class="container d-flex flex-column justify-content-center align-items-center">
        <h2>About Page: This is Public Route</h2>
      </div>
    </>
  );
};

export default About;